import { IcDownloadIcon, IcPreviewIcon, IcSDeleteIcon, IcSForwardIcon } from '@gem/icons';
import { useTranslation } from '@gem/modules/i18n';

import Tasks from 'APP/Tasks';
import { SharedDataType } from 'APP/constants/sharedData';
import { DeleteMessagesMode, PayloadType } from 'APP/model/message/messageModel.types';
import { ForwardMessagePopup } from 'MAIN/PopupManager/Popups/ForwardMessagePopup/ForwardMessagePopup';
import Entities from 'STORE';

export const useContextMenuPresenter = ({ message, itemId, sharedDataType }) => {
  const { t } = useTranslation();

  const focusMessage = async () => {
    Tasks.messaging.focusMessage({
      groupId: message.group.id,
      messageId: message.id,
    });
    if (message.group.id !== Entities.GroupsStore.activeGroupId) {
      await Tasks.group.setActiveGroup({ groupId: message.group.id });
    }
  };

  const deleteMessage = async () => {
    let canDelete = false;
    let deleteMode = DeleteMessagesMode.All;

    if (message.canBeDelete && message.canBeDeleteForMe) {
      const { isConfirmed, isChecked } = await Tasks.app.showConfirmWithCheckbox({
        text: t('delete_message'),
        checkBoxText: t('delete_for_me'),
      });

      canDelete = isConfirmed;
      deleteMode = isChecked ? DeleteMessagesMode.Me : DeleteMessagesMode.All;
    }

    if (message.canBeDelete && !message.canBeDeleteForMe) {
      canDelete = await Tasks.app.showConfirm({ text: t('delete_message') });
    }

    if (!message.canBeDelete && message.canBeDeleteForMe) {
      canDelete = await Tasks.app.showConfirm({ text: t('common_delete_for_me_alert') });
      deleteMode = DeleteMessagesMode.Me;
    }

    if (!canDelete || !message.group) {
      return;
    }

    message.delete(deleteMode);
  };

  const startForward = () => {
    Tasks.app.openPopup(ForwardMessagePopup, {
      params: { groupId: message.group.id, messageIds: [message.id] },
    });
  };

  const isLinkDataTypeFromArticle = () => {
    return (
      sharedDataType === SharedDataType.Links && message.payload.payloadType === PayloadType.Article
    );
  };

  const isMessageCanBeForwarded = (message) => {
    return message.canBeForward && message.clientUuid === itemId && !isLinkDataTypeFromArticle();
  };

  const isMessageCanBeDeleted = (message) => {
    return (
      (message.canBeDelete || message.canBeDeleteForMe) &&
      message.clientUuid === itemId &&
      !isLinkDataTypeFromArticle()
    );
  };

  const isFileCanBeDownloaded = (message) => {
    return message.canBeDownloaded;
  };

  const onDownload = () => {
    Tasks.downloadMessageFile({
      payloadId: itemId,
      groupId: message.groupId,
      messageId: message.id,
    });
  };

  const menuItems = [
    {
      key: 'focusMessage',
      isVisible: true,
      title: t('profile_media_show_message'),
      onClick: focusMessage,
      icon: IcPreviewIcon,
    },
    {
      key: 'forward',
      isVisible: isMessageCanBeForwarded(message),
      title: t('message_forward'),
      onClick: startForward,
      icon: IcSForwardIcon,
    },
    {
      key: 'download',
      isVisible: isFileCanBeDownloaded(message),
      title: t('common_download'),
      onClick: onDownload,
      icon: IcDownloadIcon,
    },
    {
      key: 'delete',
      isVisible: isMessageCanBeDeleted(message),
      title: t('chat_list_delete_single_delete_button'),
      onClick: deleteMessage,
      icon: IcSDeleteIcon,
      style: 'danger',
    },
  ];

  return {
    menuItems: menuItems.filter((item) => item.isVisible),
  };
};
